'use client'

import { useSearchStore } from '@stores/search.store'

import { FormEvent, startTransition, type JSX } from 'react'

import Button from '@components/buttons/button'
import useJobSearch from '@hooks/useJobSearch'
import { searchSubmittedEvent } from '@lib/analytics-events'

import styles from './inline-search.module.scss'

import { JobTypeAhead, LocationTypeAhead } from '../typeahead'

type InlineSearchProps = {
  source?: string
}

export default function InlineSearch({ source }: InlineSearchProps): JSX.Element {
  const nextSearch = useSearchStore((state) => state.nextSearch)
  const addParamsToSearch = useSearchStore((state) => state.addParamsToSearch)

  const { submit, errors, setError } = useJobSearch()

  const onFormSubmit = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault()
    searchSubmittedEvent({ ...nextSearch, salary: { min: 0, type: 'PER_ANNUM' } }, source || 'Inline Search component')
    submit()
  }

  return (
    <form className={styles.search} onSubmit={onFormSubmit} autoComplete="false">
      <div className={styles.typeaheads}>
        <div className={styles.job}>
          <JobTypeAhead
            currentJob={nextSearch.job}
            setJob={(job): void => startTransition(() => addParamsToSearch({ job }))}
            setShowError={(v: boolean): void => setError(v, 'job')}
            showError={errors.job}
          />
        </div>
        <div className={styles.location}>
          <LocationTypeAhead
            currentLocation={nextSearch.location}
            setLocation={(location): void => startTransition(() => addParamsToSearch({ location }))}
            setShowError={(v: boolean): void => setError(v, 'location')}
            showError={errors.location}
          />
        </div>
      </div>
      <Button data-pw="search-btn">Submit</Button>
    </form>
  )
}
